import React from "react";
import { Pagination } from "@components";
import { useIntegration } from "@hooks";

const IntegrationTable = ({ searchParams, setSearchParams }) => {
  const pageIndex          = parseInt(searchParams.get("pageIndex") || "1", 10);
  const recordCountPerPage = 10;

  // 훅에서 서버 데이터(resultList, paginationInfo, totalcount) + 선택로직 가져오기
  const {
    integrationList,  // { resultList, paginationInfo, totalcount }
    selectedItems,
    isAllChecked,
    handleSelectAll,
    handleSelectItem,
    downloadZip,
    handleExcelDownload,
  } = useIntegration();

  const list       = integrationList?.resultList || [];
  const pageInfo   = integrationList?.paginationInfo;
  const totalcount = integrationList?.totalcount || 0;

  // 페이지 변경 → URL
  const handlePageChange = (targetPage) => {
    const params = new URLSearchParams(searchParams);
    params.set("pageIndex", targetPage);
    setSearchParams(params);
  };

  const handleBulkDownload = () => {          
    if (selectedItems.length === 0) {
      alert("다운로드할 수강생을 체크하세요.");
      return;
    }
    downloadZip();                            
  };


  return (
    <>
      <div className="section-tit-wrap">
        <h3 className="border-left-primary">
          &nbsp;통합수강생 목록
          <span className="total-txt">
            | 총 <span className="red">{totalcount}</span> 건
          </span>
        </h3>
        <div className="btn-right-box">
          <ul>
            <li>              
              <button
                type="button"
                className="btn-excel"
                onClick={handleExcelDownload}
              >
                엑셀
              </button></li>
            <li><button className="btn-write" onClick={handleBulkDownload}>
                일괄 확인서
              </button></li>
          </ul>
        </div>
      </div>

      <div className="table-container">
        <table className="table-list" style={{ width: "100%" }}>
          <thead>
          <colgroup>
            <col style={{ width: "1%" }} />
            <col style={{ width: "1%" }} />
            <col style={{ width: "17%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "5%" }} />
            <col style={{ width: "5%" }} />
            <col style={{ width: "16%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "5%" }} />
            <col style={{ width: "5%" }} />
            <col style={{ width: "5%" }} />
            <col style={{ width: "5%" }} />
            <col style={{ width: "5%" }} />
            <col style={{ width: "5%" }} />
            <col style={{ width: "5%" }} />
          </colgroup>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={isAllChecked}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                />
              </th>
              <th>No</th>
              <th>강의분류</th>
              <th>강의명</th>
              <th>교육유형</th>
              <th>강의상태</th>
              <th>강의날짜</th>
              <th>수강생 ID</th>
              <th>수강생명</th>
              <th>소속회사명</th>
              {/* <th>수강신청일</th> */}
              <th>이수여부</th>
              <th>이수시간</th>
              <th>위험성평가확인서</th>
              <th>교육실시확인서</th>
            </tr>
          </thead>
          <tbody>
            {list.length > 0 ? (
              list.map((r, idx) => {
                // lectureId+memberId 조합을 key로 사용
                const key = `${r.lectureId}-${r.memberId}`;
                return (
                  <tr key={key}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedItems.includes(key)}
                        onChange={() => handleSelectItem(key)}
                      />
                    </td>
                    <td>
                      {(pageIndex - 1) * recordCountPerPage + idx + 1}
                    </td>
                    <td style={{textAlign:"left"}}>
                      {[
                        `[${r.catgRegYear}년`,     // 년도
                        `${r.eduNo}차]`,          // 차수
                        r.eduCategoryNm,          // 카테고리명
                        `(${r.eduHours}시간)`     // 교육시간
                      ].join(" ")}
                    </td>
                    <td>{r.lectureNm}</td>
                    <td>{r.eduTypeNm}</td>
                    <td>{r.lectureStatusNm}</td>
                    <td>
                      {r.firstDt}
                      {r.lastDt && ` ~ ${r.lastDt}`}
                    </td>
                    <td>{r.memberId}</td>
                    <td>{r.memberNm}</td>
                    <td>{r.companyNm}</td>
                    {/* <td>{r.applyDt}</td> */}
                    <td>{r.completeYn === "Y" ? "이수" : "미이수"}</td>
                    <td>{r.completeTime}</td>
                    <td>{r.dngrCfrmShtDt || "-"}</td>
                    <td>{r.eduCfrmShtDt || "-"}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={14} style={{ textAlign: "center" }}>
                  조회 결과가 없습니다.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {pageInfo && pageInfo.totalRecordCount > 0 && (
        <Pagination
          totalPages={Math.ceil(
            pageInfo.totalRecordCount / pageInfo.recordCountPerPage
          )}
          currentPage={pageIndex}
          onPageChange={handlePageChange}
          pageRangeDisplayed={10}
        />
      )}
    </>
  );
};

export default IntegrationTable;
